import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        actualView: 'homeView',
        // actualView: 'registerForm',
        loading: false,
        modalInfo: false,
        finalArrayAnswers: []
    },

    getters: {
        returnActualView: (state) => {
            return state.actualView;
        },
        returnLoadingState: (state) =>{
            return state.loading;
        },
        returnModalState: (state) =>{
            return state.modalInfo;
        },
        returnArrayAnswers: (state) =>{
            return state.finalArrayAnswers;
        }
    },

    mutations: {
        changeView(state, nameView) {
            state.actualView = nameView;
        },
        changeLoadingState(state, foo){
            state.loading = foo;
        },
        changeArrayAnswer(state, foo){
            state.finalArrayAnswers = foo;
        }
    },

    actions: {
        updateActualView: (context, nameView) => {
            window.scrollTo(0,0);
            context.commit("changeView", nameView);
        },
        updateLoadingState: (context, foo) => {
            window.scrollTo(0,0);
            context.commit("changeLoadingState", foo)
        },
        updateArrayAnswersState: (context, foo) => {
            context.commit("changeArrayAnswer", foo)
        }
    }


})
